import EFPicture from 'elem/compCommon/EFPicture';
import PortableDesign from '@elem/SVGIcon/VanlifeRoadtrips/PortableDesign';
import PlugAndPlay from '@elem/SVGIcon/PowerBackup/PlugAndPlay';
import Capacity from 'elem/SVGIcon/PowerBackup/Capacity';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const icons: any = [
        {
            icon: <Capacity className="color1" />,
            text: t('secJ_tag1'),
        },
        {
            icon: <PlugAndPlay className="color" />,
            text: t('secJ_tag2'),
        },
        {
            icon: <PortableDesign />,
            text: t('secJ_tag3'),
        },
    ];
    return (
        <div id="outdoor-recreation-J" className={`outdoor-recreation-J ${css['outdoor-recreation-J']}`}>
            <div className="img-box">
                <EFPicture
                    src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716539792854/j_au_1366.png"
                    srcMobile="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716540101663/j_au_375.png"
                    alt={t('secJ_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secJ_title')}</p>
                    <p className="desc">{t('secJ_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
